import { Badge } from '@/components/ui/badge';
import type { InvoiceStatus } from '@/lib/invoicing/invoiceStatusMachine';
import { statusLabel } from '@/lib/invoicing/invoiceStatusMachine';

export const InvoiceStatusBadge = ({ status }: { status: InvoiceStatus | string }) => {
  const variant = (() => {
    switch (status) {
      case 'paid': return 'default' as const;
      case 'finalized': return 'secondary' as const;
      case 'authorized': return 'outline' as const;
      case 'void': return 'destructive' as const;
      default: return 'outline' as const;
    }
  })();
  return <Badge variant={variant}>{statusLabel(status as InvoiceStatus)}</Badge>;
};
